export default{
    init(){
        this.changeChunkSize();
        this.pageSwitchButtons();
        this.showHideBigText();
        this.initDateTimes();
        this.selectOrganisation();
    },

    changeChunkSize(){
        $('#data-size').on('change', (e) => {
            let organisation = $('#organisation').val();
            let size = $('#data-size').val();
            let page_number = parseInt($('#page_number').val());
            let picker = $('#activity_logs_period').data('daterangepicker');
            if (page_number<0 || isNaN(page_number)) {
                page_number=1;
            }
            this.switchPage(organisation, size, page_number, picker.startDate.format('Y-M-D'),picker.endDate.format('Y-M-D'));
        })
    },

    pageSwitchButtons(){
        $('#previous-page-btn').click(() => {
            let organisation = $('#organisation').val();
            let size = $('#data-size').val();
            let page_number = parseInt($('#page_number').val());
            let picker = $('#activity_logs_period').data('daterangepicker');
            if (page_number <= 1 || isNaN(page_number)) {
                $(this).attr('disabled', true);
            }else{
                $(this).removeAttr('disabled');
                this.switchPage(organisation, size, page_number-1, picker.startDate.format('Y-M-D'),picker.endDate.format('Y-M-D'));
            }
        });
        $('#next-page-btn').click(() => {
            let organisation = $('#organisation').val();
            let size = $('#data-size').val();
            let page_number = parseInt($('#page_number').val())+1;
            let picker = $('#activity_logs_period').data('daterangepicker');
            if (!isNaN(page_number)) {
                this.switchPage(organisation, size, page_number, picker.startDate.format('Y-M-D'),picker.endDate.format('Y-M-D'));
            }else{
                $('#page_number').addClass('border-danger');
            }
        });
        $('#page_number').on('change', ()=>{
            let organisation = $('#organisation').val();
            let size = $('#data-size').val();
            let page_number = parseInt($('#page_number').val());
            let picker = $('#activity_logs_period').data('daterangepicker');
            if(!isNaN(page_number) && page_number>0){
                this.switchPage(organisation, size, page_number, picker.startDate.format('Y-M-D'),picker.endDate.format('Y-M-D'));
            }else{
                $('#page_number').addClass('border-danger');
            }
        });
        $('#page_number_bottom').on('change', ()=>{
            let organisation = $('#organisation').val();
            let size = $('#data-size').val();
            let page_number = parseInt($('#page_number_bottom').val());
            let picker = $('#activity_logs_period').data('daterangepicker');
            if(!isNaN(page_number) && page_number>0){
                this.switchPage(organisation, size, page_number, picker.startDate.format('Y-M-D'),picker.endDate.format('Y-M-D'));
            }else{
                $('#page_number_bottom').addClass('border-danger');
            }
        });
        $('#previous-page-bottom-btn').click(() => {
            let organisation = $('#organisation').val();
            let size = $('#data-size').val();
            let page_number = parseInt($('#page_number_bottom').val());
            let picker = $('#activity_logs_period').data('daterangepicker');
            if (page_number <= 1 || isNaN(page_number)) {
                $(this).attr('disabled', true);
            }else{
                $(this).removeAttr('disabled');
                this.switchPage(organisation, size, page_number-1, picker.startDate.format('Y-M-D'),picker.endDate.format('Y-M-D'));
            }
        });
        $('#next-page-bottom-btn').click(() => {
            let organisation = $('#organisation').val();
            let size = $('#data-size').val();
            let page_number = parseInt($('#page_number_bottom').val())+1;
            let picker = $('#activity_logs_period').data('daterangepicker');
            if (!isNaN(page_number)) {
                this.switchPage(organisation, size, page_number, picker.startDate.format('Y-M-D'),picker.endDate.format('Y-M-D'));
            } else {
                $('#page_number_bottom').addClass('border-danger');
            }
        });
    },

    switchPage(organisation, size, page_number, dateStart=null, dateEnd=null){
        let search_string = `organisation=${organisation}&size=${size}&page=${page_number}`;
        if (dateStart && dateEnd) {
            search_string += `&start=${dateStart}&end=${dateEnd}`;
        }
        window.location.search = search_string;
    },

    showHideBigText(){
        $('body').on('click', '.hide-big-text', function() {
            $(this).removeClass('hide-big-text');
            $(this).addClass('show-big-text');
        });
        $('body').on('click', '.show-big-text', function() {
            $(this).removeClass('show-big-text');
            $(this).addClass('hide-big-text');
        });
    },

    initDateTimes(){
        $('#activity_logs_period').daterangepicker();

        $('#activity_logs_period').on('apply.daterangepicker', (event, picker) => {
            let organisation = $('#search').data('organization_id') ?? $('#organisation').val();
            let size = $('#data-size').val();
            let page_number = 1;
            this.switchPage(organisation,size,page_number,picker.startDate.format('Y-M-D'),picker.endDate.format('Y-M-D'));
        })
    },

    selectOrganisation(){
        $('.activity-select-organisation').on('click', (e)=> {
            e.preventDefault();
            let organisation = $('#search').data('organization_id') ?? $('#organisation').val();
            let size = $('#data-size').val();
            let page_number = 1;
            let picker = $('#activity_logs_period').data('daterangepicker');
            this.switchPage(organisation,size,page_number,picker.startDate.format('Y-M-D'),picker.endDate.format('Y-M-D'));
        })
    },
}
